const NAMESPACE = 'STATION';

const SET_PAGE_DATA = `${NAMESPACE}/SET_PAGE_DATA`;

export {
    SET_PAGE_DATA,
};

export default NAMESPACE;
